// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SearchComponents = require("../../../reason/clients/components/SearchComponents.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SearchFilterFieldGroup = require("../../cap/Search/components/SearchFilterFieldGroup.bs.js");
let PropertiesPageRelayFilters = require("./PropertiesPageRelayFilters.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");

function PropertiesPageRelayFiltersDesktopMenu(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  let developmentsEnabled = FeaturesV3.useIsDevelopmentsEnabled() === true;
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "md",
    alignItems: "center",
    flexDirection: "row",
    children: [
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Price Range",
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(PropertiesPageRelayFilters.MinPrice.make, {
              refetch: refetch
            }),
            JsxRuntime.jsx(PropertiesPageRelayFilters.MaxPrice.make, {
              refetch: refetch
            })
          ],
          className: "flex flex-row space-x-4"
        })
      }),
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Property",
        children: JsxRuntime.jsxs(ViewStack.make, {
          children: [
            JsxRuntime.jsxs(SearchFilterFieldGroup.make, {
              children: [
                JsxRuntime.jsx(PropertiesPageRelayFilters.MinBeds.make, {
                  refetch: refetch
                }),
                JsxRuntime.jsx(PropertiesPageRelayFilters.MaxBeds.make, {
                  refetch: refetch
                })
              ]
            }),
            JsxRuntime.jsx(PropertiesPageRelayFilters.PropertyTypes.make, {
              rentalMode: rentalMode,
              refetch: refetch
            })
          ]
        })
      }),
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Areas",
        children: JsxRuntime.jsx(PropertiesPageRelayFilters.AreasItem.make, {
          selectedAreaIds: Stdlib_Option.getOr(params.areaIds, []),
          selectedAreas: props.selectedAreas,
          defaultAreas: props.defaultAreas,
          setSelectedAreas: props.setSelectedAreas,
          refetch: refetch
        })
      }),
      !rentalMode && developmentsEnabled ? JsxRuntime.jsx(SearchComponents.MenuItem.make, {
          title: "Development Projects",
          children: JsxRuntime.jsx(PropertiesPageRelayFilters.IncludeNewDevelopments.make, {
            refetch: refetch
          }),
          id: "development-projects-button"
        }) : null,
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "More Filters",
        children: JsxRuntime.jsxs(ViewStack.make, {
          children: [
            JsxRuntime.jsx(PropertiesPageRelayFilters.TANStatuses.make, {
              rentalMode: rentalMode,
              refetch: refetch
            }),
            JsxRuntime.jsx(PropertiesPageRelayFilters.Keywords.make, {
              refetch: refetch
            }),
            JsxRuntime.jsx(PropertiesPageRelayFilters.MlsStatus.make, {
              refetch: refetch
            })
          ]
        }),
        id: "more-filters-button"
      })
    ]
  });
}

let make = PropertiesPageRelayFiltersDesktopMenu;

exports.make = make;
/* ViewStack Not a pure module */
